import React, { useEffect } from 'react';
import { CardList } from "../../Components/Front-End/HomeCardSection/HomeCardSection";
import Jumpstart from "../../Components/Front-End/JumpStart/JumpStart";
import { RegisterHere } from "../../Components/Front-End/StepsRegister/Steps";
import HomeBanner from "../../Components/Front-End/HomeBanner/HomeBanner";
import ReactGA from "react-ga4";

const HomePage = () => {
    useEffect(() => {
        // --- GOOGLE TAG MANAGER INJECTION ---
        // 1. Inject the Script tag into <head>
        const script = document.createElement('script');
        script.id = 'gtm-script';
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-WVD9TPJT');`;
        document.head.appendChild(script);

        // 2. Inject the Noscript tag into <body>
        const noscript = document.createElement('noscript');
        noscript.id = 'gtm-noscript';
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WVD9TPJT"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.insertBefore(noscript, document.body.firstChild);
        // ------------------------------------

        // Your existing GA4 tracking
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
        const startTime = Date.now();

        return () => {
            // CLEANUP: Remove tags when leaving the Home Page
            const scriptToRemove = document.getElementById('gtm-script');
            const noscriptToRemove = document.getElementById('gtm-noscript');
            if (scriptToRemove) scriptToRemove.remove();
            if (noscriptToRemove) noscriptToRemove.remove();

            const duration = Math.floor((Date.now() - startTime) / 1000);
            ReactGA.event({
                category: 'User Engagement',
                action: 'Page Duration',
                label: 'Home Page',
                value: duration
            });
        };
    }, []);

    return (
        <div>
            <HomeBanner />
            <CardList />
            <Jumpstart />
            <RegisterHere />
        </div>
    );
};

export default HomePage;